// removed by extract-text-webpack-plugin
module.exports = {"container":"AxwZrMac5VBZyU-qF6Zpr","message":"_27U_F-WkHbc9bigVRb9iaP","warning":"OfQ_MbjOi8R5NMeYER74z"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Settings/Signature/BrowseVersion/styles.css
// module id = 2564
// module chunks = 0